module.exports = __webpack_public_path__ + "img/bear6.a4300c62.svg";